<template>
  <div class="gc-summary">
    <img src="../assets/images/logo-flat.svg" alt="" class="gc-summary__logo">

    <ul class="gc-summary__list">
      <li>
        <div class="gc-summary__item">
          <label for="">Book</label>
          <p v-text="donation.title"></p>
        </div>
      </li>

      <li>
        <div class="gc-summary__item">
          <label for="">Author(s)</label>
          <p v-text="donation.authors"></p>
        </div>
      </li>

      <li>
        <div class="gc-summary__item">
          <label for="">Edition</label>
          <p v-text="donation.edition"></p>
        </div>
      </li>

      <li>
        <div class="gc-summary__item">
          <label for="">Chief's Name</label>
          <p v-text="donation.name"></p>
        </div>
      </li>

      <li>
        <div class="gc-summary__item">
          <label for="">Email</label>
          <p v-text="donation.email"></p>
        </div>
      </li>

      <li>
        <div class="gc-summary__item">
          <label for="">Phone</label>
          <p v-text="donation.phone"></p>
        </div>
      </li>

      <li>
        <div class="gc-summary__item">
          <label for="">Prefered Hub</label>
          <p v-text="donation?.hubDetails?.name"></p>
        </div>
      </li>
    </ul>

    <div class="gc-summary__button-group">
      <button
        type="button"
        class="gc-summary__button gc-summary__button--cancel"
        @click="$emit('onCancel')"
      > Cancel
      </button>

      <button
        class="gc-summary__button"
        type="button"
        @click="$emit('onSubmit')">
        Submit
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    donation: { type: Object, required: true }
  },
  emits: ['onCancel', 'onSubmit']
}
</script>

<style lang="scss" scoped>
  .gc-summary {
    margin: 1.6rem;

    &__logo {
      width: 15rem;
      margin: 2rem auto;
      display: block;
    }

    &__list {
      list-style: none;

      & > li:not(:last-child) {
        border-bottom: 1px solid var(--color-secondary);
      }
    }

    &__item {
      display: grid;
      grid-template-columns: 30% 65%;
      align-items: center;
      justify-content: space-between;
      padding: 1.6rem;

      label {
        font-size: 1.6rem;
        font-weight: 400;
      }

      p {
        font-size: 1.8rem;
        text-align: right;
        font-weight: 600;

        &:first-letter {
          text-transform: capitalize;
        }
      };
    }

    &__button-group {
      margin: 4rem 0;
      text-align: center;
    }

    &__button {
      border: none;
      border-radius: 5px;
      padding: 1.2rem 3rem;
      font-size: 1.4rem;
      color: white;
      background: var(--color-secondary);
      font-weight: 600;
      text-transform: uppercase;
      cursor: pointer;
      box-shadow: 0 0.4rem 1.2rem rgb(22 30 46 / 16%);

      &--cancel {
        color: var(--color-text);
        background: white;
        margin-right: 2rem;
      }
    }
  }
</style>
